import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import DashboardAccessModal from '../common/DashboardAccessModal';
// import ComingSoonModal from '../common/ComingSoonModal';
import { getAdminConfigService } from '../../Services/AdminConfigService';
import './navigation.css';
import reportIcon from './icons/mdi_report-box-outline.png';
import marketIcon from './icons/icon-park-solid_stock-market.png';
import snippetsIcon from './icons/material-symbols_text-snippet-outline-rounded.png';
import dashboardIcon from './icons/material-symbols_dashboard-outline-rounded.png';

const MobileBottomNav = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const [showDashboardModal, setShowDashboardModal] = useState(false);
    const [isDashboardEnabled, setIsDashboardEnabled] = useState(false);
    const [loadingDashboardConfig, setLoadingDashboardConfig] = useState(true);

    // Load dashboard configuration
    useEffect(() => {
        const loadDashboardConfig = async () => {
            try {
                const adminConfigService = getAdminConfigService();
                const enabled = await adminConfigService.isDashboardEnabled();
                setIsDashboardEnabled(enabled);
            } catch (error) {
                console.error('Error loading dashboard config:', error);
                setIsDashboardEnabled(false);
            } finally {
                setLoadingDashboardConfig(false);
            }
        };

        if (user) {
            loadDashboardConfig();
        }
    }, [user]);

    if (!user) return null;

    // External dashboard link for logged-in users - COMMENTED FOR FUTURE USE
    const accessToken = user.firebaseUser ? user.firebaseUser.accessToken : 'demoToken';
    const uid = user.firebaseUser ? user.firebaseUser.uid : 'demoUid';
    // const dashboardExternalUrl = `https://invest.rightspade.com/user?accessToken=${encodeURIComponent(accessToken)}&uid=${encodeURIComponent(uid)}`;
    const dashboardExternalUrl_temp = 'https://invest.rightspade.com';
    const handleDashboardClick = () => {
        console.log('handleDashboardClick');
        if (user.status.toLowerCase() === "approved") {
            // if (isDashboardEnabled) {
            //     // Open external dashboard in the same window/tab
            //     window.location.href = dashboardExternalUrl;
            // } else {
            //     // Show modal if dashboard is disabled
            //     setShowDashboardModal(true);
            // }
            window.location.href = dashboardExternalUrl_temp;
            // window.location.href = signedUrl;
        } else {
            setShowDashboardModal(true);
        }
    };

    const handleCloseDashboardModal = () => setShowDashboardModal(false);
    // Icons are decorative (alt="") — the visible label names each link; a
    // duplicate alt made screen readers announce each name twice (docx round-2)
    const navItems = [
        { label: 'Right Report', to: '/dashboard/reports', icon: <img src={reportIcon} alt="" width={22} height={22} /> },
        { label: 'Right Now', to: '/dashboard/market-overview', icon: <img src={marketIcon} alt="" width={22} height={22} /> },
        { label: 'Right Snippets', to: '/dashboard/market-wrap', icon: <img src={snippetsIcon} alt="" width={22} height={22} /> },
        { label: 'Dashboard', action: handleDashboardClick, icon: <img src={dashboardIcon} alt="" width={22} height={22} />, isDashboard: true },
    ];

    return (
        <>
            <div className="mobile-bottom-nav">
                <nav className="mobile-bottom-nav d-flex justify-content-around align-items-center" aria-label="Bottom navigation">
                    {/* Real <Link>/<button> elements, not <div onClick> — divs are
                        unreachable by keyboard (auditor critical, round-3) */}
                    {navItems.map((item) => {
                        const isActive = !item.isDashboard && location.pathname === item.to;
                        const cls = `mobile-bottom-nav-item${isActive ? ' active' : ''}`;
                        return item.isDashboard ? (
                            <button
                                key={item.label}
                                type="button"
                                className={cls}
                                onClick={item.action}
                            >
                                {item.icon}
                                <span className="mobile-bottom-nav-label">{item.label}</span>
                            </button>
                        ) : (
                            <Link
                                key={item.label}
                                to={item.to}
                                className={cls}
                                aria-current={isActive ? 'page' : undefined}
                            >
                                {item.icon}
                                <span className="mobile-bottom-nav-label">{item.label}</span>
                            </Link>
                        );
                    })}
                </nav>
            </div>

            {/* Dashboard Access Modal */}
            <DashboardAccessModal
                show={showDashboardModal}
                onHide={handleCloseDashboardModal}
            />

            {/* Coming Soon Modal - COMMENTED OUT FOR FUTURE USE */}
            {/* <ComingSoonModal
                show={showDashboardModal}
                onHide={handleCloseDashboardModal}
                title="Enhanced Dashboard for Research Clients"
                icon="🔧"
                description="We're building a powerful new experience to help you track equity research recommendations and make informed investment decisions — with greater transparency and control."
                features={[
                    "Advanced Analytics Dashboard",
                    "Real-time Market Data Integration",
                    "Performance Tracking of Research Calls"
                ]}
                disclaimer="For actionable insights, please refer to our SEBI-compliant published research reports. Investing involves risk. Past performance is not indicative of future results. Terms and Conditions apply. Please review the Investor Charter."
                primaryButtonText="Go to Market Overview"
                primaryButtonAction="/dashboard/market-overview"
            /> */}
        </>
    );
};

export default MobileBottomNav; 